import { DefaultLayout, WebLayout } from "../layouts";
import Dashboard from "../pages/Dashboard/Dashboard";
import UserList from "../pages/Users/UserList";
import { Updateaccountdetails } from "../pages/Acount/Updateaccountdetails";
import OrganizationList from "../pages/Organization/OrganizationList";
import Homepage from "../layouts/Homepage";
import Budgets from "../pages/Budget/Budget";
import Category from "../pages/Category/Category";
import ViewOrganization from "../pages/Organization/ViewOrganization";
import Reports from "../pages/Reports/Reports";
import DataElements from "../pages/DataElements/DataElements";
import ConfirmDeleteModal from "../components/Comman/ConfirmDeleteModal/ConfirmDeleteModal";
import ImageSelect from "../components/Comman/ImageSelect/ImageSelect";
import UserDashboard from "../pages/UserPages/Dashboard/UserDashboard";
import SubmissionStatus from "../pages/SubmissionStatus/SubmissionStatus";
import DataReviewListing from "../pages/DataReview/DataReviewListing";
import AdminRequests from "../pages/AdminRequests/AdminRequests";
import PrivacyPolicy from "../pages/PrivacyPolicy/PrivacyPolicy";
import AboutUs from "../pages/AboutUs/AboutUs";
import Setting from "../pages/Settings/Setting";
import ViewDataElements from "../pages/DataElements/ViewDataElements";
import ViewUser from "../pages/Users/ViewUser";

export const GlobalAdminRoutes = [
  {
    path: "/",
    exact: true,
    layout: WebLayout,
    component: Homepage,
  },
  {
    path: "/admin/dashboard",
    exact: true,
    layout: DefaultLayout,
    component: Dashboard,
  },
  // {
  //   path: "/admin/settings",
  //   exact: true,
  //   layout: DefaultLayout,
  //   component: Setting,
  // },
  {
    path: "/admin/budgets",
    exact: true,
    layout: DefaultLayout,
    component: Budgets,
  },
  {
    path: "/admin/categories",
    exact: true,
    layout: DefaultLayout,
    component: Category,
  },
  {
    path: "/admin/users",
    exact: true,
    layout: DefaultLayout,
    component: UserList,
  },
  {
    path: "/admin/organizations",
    exact: true,
    layout: DefaultLayout,
    component: OrganizationList,
  },
  {
    path: "/admin/view-organization/:id",
    exact: true,
    layout: DefaultLayout,
    component: ViewOrganization,
  },
  // {
  //   path: "/change-password",
  //   exact: true,
  //   layout: DefaultLayout,
  //   component: updatedPassword,
  // },
  {
    path: "/profile",
    exact: true,
    layout: DefaultLayout,
    component: Updateaccountdetails,
  },
  {
    path: "/admin/reports",
    exact: true,
    layout: DefaultLayout,
    component: Reports,
  },
  {
    path: "/admin/data-elements",
    exact: true,
    layout: DefaultLayout,
    component: DataElements,
  },
  {
    path: "/admin/modal",
    exact: true,
    layout: DefaultLayout,
    component: ConfirmDeleteModal,
  },
  {
    path: "/admin/select",
    exact: true,
    layout: DefaultLayout,
    component: ImageSelect,
  },

  {
    path: "/user/dashboard",
    exact: true,
    layout: DefaultLayout,
    component: UserDashboard,
  },
  {
    path: "/admin/submission-status",
    exact: true,
    layout: DefaultLayout,
    component: SubmissionStatus,
  },
  {
    path: "/admin/data-review",
    exact: true,
    layout: DefaultLayout,
    component: DataReviewListing,
  },
  {
    path: "/admin/requests",
    exact: true,
    layout: DefaultLayout,
    component: AdminRequests,
  },
  {
    path: "/privacy",
    exact: true,
    layout: DefaultLayout,
    component: PrivacyPolicy,
  },
  {
    path: "/terms-and-conditions",
    exact: true,
    layout: DefaultLayout,
    component: AboutUs,
  },

  {
    path: "/settings",
    exact: true,
    layout: DefaultLayout,
    component: Setting,
  },
  {
    path: "/admin/view/data-element/:id",
    exact: true,
    layout: DefaultLayout,
    component: ViewDataElements,
  },
  {
    path: "admin/view/user/:id",
    exact: true,
    layout: DefaultLayout,
    component: ViewUser,
  },
];
